// src\blocks\Custom\Header78\Component.tsx

'use client'

import React, {  useState, useEffect } from 'react'
import type { Media, Page } from '@/payload-types'
import { CMSLink } from '@/components/Link'
// import { useTheme } from '@/providers/Theme'
import RichText from '@/components/RichText'
// import RevealHeading from '@/components/RevealHeading'
import FramerReveal from '@/components/framer-reveal-component'

type Props = Extract<Page['layout'][0], { blockType: 'header78' }>
// type Theme = 'light' | 'dark' | 'auto'



export const Header78Block: React.FC<Props> = ({
    description,
    images,
    enableButtons,
    links,
    theme
}) => {
   
    return (
        <section
            className="bg-background"
            data-theme={theme}>
            <div className="container grid grid-cols-1 gap-y-16 pt-16 md:grid-flow-row md:pt-24 lg:grid-flow-col lg:grid-cols-2 lg:items-center lg:pt-0">
                <div className=" mb-12 ">
                    {description && <RichText data={description} enableProse={true} />}
                    <FramerReveal>
                        {enableButtons && links && (
                            <div className="mt-6 flex items-center justify-center gap-x-4 md:mt-8">
                                {(links || []).map((link, i) => (
                                    <CMSLink key={i} {...link} />
                                ))}
                            </div>
                        )}
                    </FramerReveal>
                </div>

                <div className="h-[30rem] overflow-hidden pl-[5vw] pr-[5vw] md:h-[40rem] lg:h-screen lg:pl-0">
                    <div className="grid w-full grid-cols-2 gap-x-4">
                        <div className="-mt-[120%] grid size-full animate-loop-vertically columns-2 grid-cols-1 gap-4 self-center">
                            {images.map((image, index) => (
                                <div key={index} className="grid size-full grid-cols-1 gap-4">
                                    <div className="relative w-full pt-[120%]">
                                        <img
                                            className="absolute inset-0 size-full object-cover"
                                            src={(image as Media)?.url!}
                                            alt={(image as Media)?.alt!}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="grid size-full animate-loop-vertically grid-cols-1 gap-4">
                            {images.map((image, index) => (
                                <div key={index} className="grid size-full grid-cols-1 gap-4">
                                    <div className="relative w-full pt-[120%]">
                                        <img
                                            className="absolute inset-0 size-full object-cover"
                                            src={(image as Media)?.url!}
                                            alt={(image as Media)?.alt!}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

        </section>
    )
}



